import lod_ from "lodash";
import { Collapse, Divider, Icon } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { LittleForm } from "components/Custom/LittleForm";
import { queryDictionary } from "helpers/dictionary";
import { createDictionarySkeleton } from "helpers/form";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

/**
 * Theme configuration form, used in theme edition dialog. It will generate a form based on the themeConfigDictionary and the values of the asset
 * @returns {*} JSX Element
 */
const ThemeConfigForm = ({ asset = {}, handleChange = () => {} }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const [dictionary, setDictionary] = useState({});
	const [skeleton, setSkeleton] = useState({});
	const [showAdvanced, setShowAdvanced] = useState(false);

	const getDictionary = async code => {
		const dictionaryResult = await queryDictionary(dispatch, code);
		const buildedSkeleton = createDictionarySkeleton(
			dictionaryResult,
			asset.values?.faqConfig || {}
		);

		setDictionary(dictionaryResult);
		setSkeleton(buildedSkeleton);
	};

	useEffect(() => {
		getDictionary("themeConfigDictionary");
	}, []);

	useEffect(() => {
		if (lod_.isEmpty(dictionary)) return;
		const buildedSkeleton = createDictionarySkeleton(dictionary, asset.values?.faqConfig || {});
		setSkeleton(buildedSkeleton);
	}, [asset, dictionary]);

	return (
		<MDBox>
			{/* Discreet toggle to reveal the advanced configuration form */}
			<MDTypography
				variant="button"
				fontWeight="regular"
				color="info"
				onClick={() => setShowAdvanced(prev => !prev)}
				sx={{
					cursor: "pointer",
					textDecoration: "underline",
					display: "inline-block",
					mt: 0.5,
					mb: 1
				}}
			>
				{showAdvanced
					? t("SOURCES.ASSET.THEME_CONFIG.hideAdvanced")
					: t("SOURCES.ASSET.THEME_CONFIG.showAdvanced")}
			</MDTypography>

			<Collapse in={showAdvanced} timeout="auto" unmountOnExit>
				{/* Informative banner: explains what this configuration is for */}
				<MDBox
					display="flex"
					alignItems="flex-start"
					p={1.5}
					mt={1}
					mb={1}
					sx={{
						backgroundColor: "rgba(26, 115, 232, 0.08)",
						borderRadius: "8px",
						border: "1px solid rgba(26, 115, 232, 0.2)"
					}}
				>
					<Icon fontSize="small" sx={{ color: "info.main", mr: 1, mt: 0.2 }}>
						info
					</Icon>
					<MDTypography variant="caption" color="text" sx={{ lineHeight: 1.4 }}>
						{t("SOURCES.ASSET.THEME_CONFIG.banner")}
					</MDTypography>
				</MDBox>

				<LittleForm object={dictionary} metadatasSkeleton={skeleton} handleChange={handleChange} />
			</Collapse>
		</MDBox>
	);
};

export default ThemeConfigForm;
